import Lenis from "@studio-freight/lenis";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { Animation } from "./js/animation";
import "./js/Transport";
import "./js/navigation";
import "./js/activity";
import "./js/BookingCalendar";
import "./js/InfiniteGallery";
import "./js/ButtonBooking";
import "./js/map";
import "./js/Slider";

gsap.registerPlugin(ScrollTrigger);
/**
 * set for footer overlay
 */
const body = document.body;
// mainContainer.style.marginBottom = `${footer.offsetHeight}px`

let lenis = null;

lenis = new Lenis({
  // smooth: true,
  duration: 0.9,
  anchors: true,
  easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
});

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

window.lenis = lenis;

// continueSite()

/**
 * Cretae page animation
 */
new Animation();
